import { render, staticRenderFns } from "./user-pdfs-list.vue?vue&type=template&id=4ce33c80&"
import script from "./user-pdfs-list.vue?vue&type=script&lang=js&"
export * from "./user-pdfs-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports